import { render, staticRenderFns } from "./confirm.template.vue?vue&type=template&id=2e8722b3&scoped=true&"
var script = {}
import style0 from "./confirm.template.vue?vue&type=style&index=0&id=2e8722b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8722b3",
  null
  
)

export default component.exports